import FacebookShare from './FacebookSharingDirective';

import 'edge/platform/facebook/module';

export default angular.module('edge.platform.widgets.facebooksharing', ['edge.platform.facebook']).directive('gwFacebookSharing', FacebookShare);


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/facebook/module.js
// module id = 1960
// module chunks = 0